import type { ReactNode } from 'react';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import type { i18n as I18nInstance } from 'i18next';
import { TooltipProvider } from '@cedarreachai/ui';
import { ErrorBoundary } from '@/app/errorBoundary';
import { AppUiMessagesProvider } from '@/lib/i18n/uiMessages';
import { AuthGate } from '@/app/auth/AuthGate';

export interface ProvidersProps {
  readonly queryClient: QueryClient;
  readonly i18n: I18nInstance;
  readonly children: ReactNode;
}

/** Every cross-cutting provider, in one place so tests can mount the same stack. */
export function Providers({ queryClient, i18n, children }: ProvidersProps) {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <AppUiMessagesProvider>
          <QueryClientProvider client={queryClient}>
            <TooltipProvider delayDuration={200}>
              <AuthGate>{children}</AuthGate>
            </TooltipProvider>
          </QueryClientProvider>
        </AppUiMessagesProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}
